import Ajax from '@utils/ajax';

export default {
  fetch(data = {}, options = {}) {
    return Ajax.get({
      url: `/bookmarks`,
      data: data,
      ...options,
    });
  },

  create(data, options = {}) {
    return Ajax.post({
      url: `/bookmarks`,
      data: data,
      ...options,
    });
  },

  delete(data, options = {}) {
    return Ajax.post({
      url: `/bookmarks/destory`,
      data: {
        ...data,
      },
      ...options,
    });
  },
};
